"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Loader = _interopRequireDefault(require("../../Loader"));
var _finalizeAddPaymentDetailsSlice = require("../../../redux/finalizeAddPaymentDetailsSlice");
var _paymentDetailsSlice = require("../../../redux/paymentDetailsSlice");
var _popupSlice = require("../../../redux/popupSlice");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FinalizeAddPaymentDetails = () => {
  const adyenRedirectResult = new URLSearchParams(window.location.search).get('redirectResult');
  const paymentMethodId = new URLSearchParams(window.location.search).get('paymentMethodId');
  const dispatch = (0, _reactRedux.useDispatch)();
  const submitRedirectResult = () => {
    dispatch((0, _finalizeAddPaymentDetailsSlice.fetchFinalizeAddPaymentDetails)({
      paymentMethodId,
      details: {
        redirectResult: adyenRedirectResult
      }
    })).unwrap().then(() => {
      dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        step: _popupSlice.PAYMENT_DETAILS_STEPS.SUCCESS,
        isLoading: false
      }));
      dispatch((0, _paymentDetailsSlice.fetchPaymentDetails)());
    }).catch(() => {
      dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        step: _popupSlice.PAYMENT_DETAILS_STEPS.ERROR
      }));
    }).finally(() => {
      window.history.replaceState(null, null, window.location.pathname);
    });
  };
  (0, _react.useEffect)(() => {
    if (adyenRedirectResult && paymentMethodId) {
      submitRedirectResult();
    }
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {});
};
var _default = exports.default = FinalizeAddPaymentDetails;